module.exports = __webpack_public_path__ + "static/media/codebot_body.04d5095d.svg";